module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "Dashboardpdf",
    attrs: {
      "id": "Dashboardpdf"
    }
  }, [_c('section', {
    staticClass: "dashboard"
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showDash == true) ? _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h4', {
    staticClass: "page-title mb-1"
  }, [_vm._v("DASHBOARD")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": _vm.goToClientDashboard
    }
  }, [_vm._v("Client TEUS Dashboard")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('date-range-picker', {
    staticClass: "mb-1",
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.getData
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.branchList,
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.branchfilter),
      callback: function($$v) {
        _vm.branchfilter = $$v
      },
      expression: "branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "All"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 text-right"
  }, [_c('b-button-group', {
    staticClass: "ml-1",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "outline-info"
    },
    on: {
      "click": _vm.dashboardReports
    }
  }, [_vm._v("Reporting")])], 1), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "outline-info"
    },
    on: {
      "click": _vm.getPDF
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "outline-info"
    },
    on: {
      "click": _vm.goEveryDaySale
    }
  }, [_vm._v("\n            Day Wise Sale\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "outline-info"
    },
    on: {
      "click": _vm.goEveryDayExpense
    }
  }, [_vm._v("\n            Day Wise Exp\n          ")])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "gutr mt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-3 col-sm-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Total Executions")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.totalExec) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-3",
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._v("\n                        Export " + _vm._s(_vm.totalExport) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Import " + _vm._s(_vm.totalImport))])])]), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("person_add")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-sm-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Sea Shipments")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.totalSeaShipment) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-3",
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._v("\n                        Export " + _vm._s(_vm.seaShipmentExport) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Import " + _vm._s(_vm.seaShipmentImport))])])]), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("directions_boat")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-sm-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Air Shipments")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.totalAirShipment) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-3",
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._v("\n                        Export " + _vm._s(_vm.airShipmentExport) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Import " + _vm._s(_vm.airShipmentImport))])])]), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("flight")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3 col-sm-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Container Shipped")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.totalContainerShiped) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-3",
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._v("\n                        Export " + _vm._s(_vm.containerShipedExport) + "\n                      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n                        Import " + _vm._s(_vm.containerShipedImport) + "\n                      ")])])]), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("import_export")])], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  }, [(_vm.totalExec != '0') ? _c('div', {
    staticClass: "col-md-6 grid-margin stretch-card"
  }, [_c('b-card', {
    staticClass: "formCardDash topFiveHeight"
  }, [_c('b-card-text', [_c('div', [_c('h5', {
    staticClass: "card-title mt-3"
  }, [_vm._v("Executions By Modules")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticClass: "mt-3",
    attrs: {
      "type": "pie",
      "width": "430",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  }) : _vm._e()], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Enquiry")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                      " + _vm._s(_vm.totalEnq) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted mt-3",
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._v("\n                      Existing Client " + _vm._s(_vm.totalEnqExistClient) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Leads " + _vm._s(_vm.totalEnqLead))])])]), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("add_ic_call")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("New Clients")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_vm._v("\n                        " + _vm._s(_vm.newClientAdded) + "\n                      ")])])]), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x"
  }, [_vm._v("person_add")])], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  }, [_c('div', {
    staticClass: "col-md-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Total Revenue")])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.CustomTypeList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.getData()
      }
    },
    model: {
      value: (_vm.typeFilter),
      callback: function($$v) {
        _vm.typeFilter = $$v
      },
      expression: "typeFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }, [_vm._v("\n                    ("), _c('span', [_vm._v("Sales && Expense")]), _vm._v(")\n                    "), _c('h4', {
    staticClass: "card-title font-weight-bold mb-0"
  }, [_c('h4', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("\n                        INV ₹ " + _vm._s(_vm.totalTallyAddedRevenueSum) + "\n                      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                        EXP ₹ " + _vm._s(_vm.totalTallyAddedRevenueSumExp) + "\n                      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "#ff6a00"
    }
  }, [_vm._v("\n                        NET ₹ " + _vm._s(_vm.totalTallyAddedRevenueSumNET) + "\n                      ")]), _vm._v(" "), _c('br')])])], 1), _vm._v(" "), _c('div', [_c('md-icon', {
    staticClass: "md-size-1x pull-right"
  }, [_vm._v("account_balance")])], 1)])])])]), _vm._v(" "), (_vm.chartOptionsClientReven.length > 0) ? _c('div', {
    staticClass: "col-xl-8 col-sm-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Revenue By Clients")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("Top 10")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsRev == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-20px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "340",
      "options": _vm.chartOptionsClientReven,
      "series": _vm.seriesClientRev
    }
  }) : _vm._e()], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.chartOptionsConBar.length > 0) ? _c('div', {
    staticClass: "col-md-7 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Container Type")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-20px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "300",
      "options": _vm.chartOptionsConBar,
      "series": _vm.seriesConBar
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.chartOptionsShipBar.length > 0) ? _c('div', {
    staticClass: "col-md-5 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Shipping Line")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("\n                Top 5 with No.of container Shipped\n              ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-20px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "300",
      "options": _vm.chartOptionsShipBar,
      "series": _vm.seriesShipBar
    }
  }) : _vm._e()], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.topDestinationExportData.length > 0) ? _c('div', {
    staticClass: "col-md-4 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Export Destination")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("\n                Top 5 with No.of container Shipped\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "template-demo"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', _vm._l((_vm.topDestinationExportData), function(item4, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "pl-0"
    }, [_vm._v(_vm._s(item4.exportDestinationName))]), _vm._v(" "), _c('td', {
      staticClass: "pr-0 text-right"
    }, [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v("\n                          " + _vm._s(item4.sumOfContainerExportDestination) + "\n                        ")])], 1)])
  }))])])])])]) : _vm._e(), _vm._v(" "), (_vm.topDestinationImportData.length > 0) ? _c('div', {
    staticClass: "col-md-4 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card formCardDash topFiveHeight"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Import Destination")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("\n                Top 5 with No.of container Shipped\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "template-demo"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', _vm._l((_vm.topDestinationImportData), function(item5, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "pl-0"
    }, [_vm._v(_vm._s(item5.importDestiName))]), _vm._v(" "), _c('td', {
      staticClass: "pr-0 text-right"
    }, [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v("\n                          " + _vm._s(item5.sumOfContainerImportDestination) + "\n                        ")])], 1)])
  }))])])])])]) : _vm._e(), _vm._v(" "), (_vm.topLoadPortData.length > 0) ? _c('div', {
    staticClass: "col-md-4 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card formCardDash topFiveHeight"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Port of Loading Export")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("\n                Loading Ports with No.of container Shipped\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "template-demo"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', _vm._l((_vm.topLoadPortData), function(item6, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "pl-0"
    }, [_vm._v(_vm._s(item6.topLoadPort))]), _vm._v(" "), _c('td', {
      staticClass: "pr-0 text-right"
    }, [_c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v("\n                          " + _vm._s(item6.sumOfContainerLoadPort) + "\n                        ")])], 1)])
  }))])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  }, [(_vm.topCommodityExportData.length > 0) ? _c('div', {
    staticClass: "col-md-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Most Exported Commodity")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("Top 5 (Sea)")]), _vm._v(" "), _c('div', {
    staticClass: "template-demo"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', _vm._l((_vm.topCommodityExportData), function(item3, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "pl-0"
    }, [_vm._v(_vm._s(item3.itemDescription))]), _vm._v(" "), _c('td', {
      staticClass: "pr-0 text-right"
    }, [_c('b-badge', {
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v("\n                          " + _vm._s(item3.commodityCount) + "\n                        ")])], 1)])
  }))])])])])]) : _vm._e(), _vm._v(" "), (_vm.chartOptionsExCom.length > 0) ? _c('div', {
    staticClass: "col-md-6 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card formCardDash",
    staticStyle: {
      "height": "340px"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Most Exported Commodity")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("Top 5 (Sea)")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-20px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "300",
      "options": _vm.chartOptionsExCom,
      "series": _vm.seriesExCom
    }
  }) : _vm._e()], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  }, [(_vm.chartOptionstopAirline.length > 0) ? _c('div', {
    staticClass: "col-md-4 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h5', {
    staticClass: "card-title"
  }, [_vm._v("Top 10 Airlines Used")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("Export")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-30px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "240",
      "options": _vm.chartOptionstopAirline,
      "series": _vm.seriestopAirline
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.chartOptionsDeparture.length > 0) ? _c('div', {
    staticClass: "col-md-4 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Top Departure Airports Export")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("\n                Top 10 with No.of Packages (Air)\n              ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart55"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-30px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "240",
      "options": _vm.chartOptionsDeparture,
      "series": _vm.seriesDeparture
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.chartOptionsArrive.length > 0) ? _c('div', {
    staticClass: "col-md-4 grid-margin stretch-card"
  }, [_c('div', {
    staticClass: "card formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Top Destination Airports Export")]), _vm._v(" "), _c('p', {
    staticClass: "card-description text-muted"
  }, [_vm._v("\n                Top 10 By No.of Packages (Air)\n              ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart22"
    }
  }, [(_vm.showgraphsAir == true) ? _c('apexchart', {
    staticStyle: {
      "margin-top": "-30px",
      "margin-left": "-25px"
    },
    attrs: {
      "type": "bar",
      "height": "240",
      "options": _vm.chartOptionsArrive,
      "series": _vm.seriesArrive
    }
  }) : _vm._e()], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  })], 1) : _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [(_vm.showDash == false) ? _c('b-navbar-brand', [(_vm.employeeName != '') ? _c('h4', {
    staticClass: "page-title"
  }, [_vm._v("\n            Welcome\n            "), _c('small', [_vm._v(_vm._s(_vm.employeeName))])]) : _vm._e()]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc4b85ee","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/dashboard/dashboard.vue
// module id = 2847
// module chunks = 0